import { formatDate } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "formatDateString",
  standalone: false,
  pure: true
})
export class FormatDateStringPipe implements PipeTransform {
  transform(firstDateTime: string | Date, formatString?: string): string {
    return stringToDate(firstDateTime, formatString);
  }
}
const stringToDate = (firstDateTime: string | Date, formatString?: string): string => {
  const formattedDate = formatDate(
    new Date(firstDateTime),
    formatString ?? "MM/dd/yyyy h:mma",
    "en-US"
  );
  return formattedDate;
};
